import React from "react";
import { SearchIcon } from "assets";
import "./InputSearchIcon.scss";

export const InputSearchIcon = () => {
  return (
    <div className="c-input-search-icon__container">
      <div className="c-input-search-icon" aria-label="Search">
        <SearchIcon />
      </div>
    </div>
  );
};
